module.exports = __webpack_public_path__ + "img/thumbnail_Wisent_f_normal.f98cf7d8.png";